import React from 'react';

export default function BranchIntro(props) {
  return (
    <div className="flex omi-bg-branch-intro">
      <div className="flex items-center lg:p-0 lg:pt-12 lg:mt-2 lg:flex-col lg:w-full">
        <div className="omi-branch-intro ml-4 sm:ml-10 lg:ml-0">
          <div className="flex sm:mb-3 lg:justify-center lg:my-10 lg:mb-10 lg:pb-1">
            <img
              className="w-3/5 sm:w-3/6 lg:w-o-1/2"
              src={require('assets/svg/Logo.svg').default}
              alt="logo"
              title="logo"
            />
          </div>
          <div className="flex pt-4 pb-5 lg:pb-4 lg flex-col">
            {props.isSignup ? (
              <>
                <p className="text-base text-grey-100 f-semibold sm:text-3xl lg:tracking-normal lg:text-xxl lg:text-center lg:leading-10">
                  Cảm ơn bạn đã tin tưởng
                </p>
                <p className="text-base text-grey-100 f-semibold sm:text-3xl lg:tracking-normal lg:text-xxl lg:text-center ">
                  và lựa chọn Omini PI!
                </p>
              </>
            ) : (
              <>
                <p className="text-base text-grey-100 f-semibold sm:text-3xl lg:tracking-normal lg:text-xxl lg:text-center lg:leading-10">
                  Quản lý nhà thuốc
                </p>
                <p className="text-base text-grey-100 f-semibold sm:text-3xl lg:tracking-normal lg:text-xxl lg:text-center">
                  dễ dàng với Omni PI
                </p>
              </>
            )}
          </div>
          <div className="hidden flex justify-center sm:block lg:mt-1">
            <p className="text-sm c-branch sm:text-xs text-grey-300 sm:text-1xl lg:tracking-normal  lg:text-sm lg:text-center lg:leading-5">
              Chúng tôi nỗ lực hết mình để mang đến những trải nghiệm
            </p>
            <p className="text-sm c-branch sm:text-xs text-grey-300 sm:text-1xl lg:tracking-normal  lg:text-sm lg:text-center">
              tốt nhất và giúp việc kinh doanh của bạn thành công
            </p>
          </div>
        </div>
        <div className="omi-branch-logo  lg:ml-0 lg:mt-16 lg:pt-2">
          <div className="flex justify-center relative omi-branch-image lg:static sm:w-4/5 sm:px-8 sm:w-full lg:px-0">
            <img
              className="lg:w-full"
              src={require('assets/svg/Sign_in_up.svg').default}
              alt="branchImage"
              title="branchImage"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
